// Статические фоновые картинки
import reg1 from '../../images/frontend/reg-1.png';
import reg2 from '../../images/frontend/reg-2.png';

import pictureTpl from '../../templates/partials/picture.hbs';

/**
 * Активация фоновых картинок
 */
export default () => {
    const regPictures = [reg1, reg2];
    const $imageContainer = $('.js-cart-auth-message');

    regPictures.forEach((image, index) => {
        const $picture = $(
            pictureTpl({
                image,
                className: `cart-auth-message__picture cart-auth-message__picture-${index + 1}`,
            })
        );

        $imageContainer.prepend($picture);
    });
};
